import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import {
  faLandmark,
  faPhone,
  faEnvelope,
} from "@fortawesome/free-solid-svg-icons";

import SocialMediaComponent from "./SocialMediaComponent";

import logo from "../../assests/oba_logo_nbg.png";

export default function FooterComponent() {
  const [showScroll, setShowScroll] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 300) {
        setShowScroll(true);
      } else {
        setShowScroll(false);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <footer
      className="shadow"
      style={{
        backgroundColor: "#FFFFFF",
        paddingTop: "40px",
      }}
    >
      <div className="container">
        <div className="row g-4">
          {/* Left Column - About */}
          <div className="col-12 col-sm-6 col-lg-4">
            <img
              src={logo}
              alt="Old Boys' Association of Vidyaloka College Logo"
              style={{ height: "80px", marginBottom: "15px" }}
            />
            <p className="text-secondary">
              Established in 1953, Old Boys' Association of Vidyaloka College is
              the alumni organization for Vidyaloka College in Galle, Sri Lanka.
              Its main purpose is to foster a strong community among former
              students and support the development of the college.
            </p>
          </div>

          {/* Quick Links Column */}
          <div className="col-12 col-sm-6 col-lg-4">
            <h5 className="mb-4 fw-bold">Quick Links</h5>
            <ul className="list-unstyled text-secondary">
              <li className="mb-2">
                <i className="bi bi-chevron-right me-2"></i>
                <Link
                  to="/old-boys-association"
                  className="text-secondary text-decoration-none"
                >
                  Old Boys' Association
                </Link>
              </li>
              {/* <li className="mb-2">
                <i className="bi bi-chevron-right me-2"></i>
                <Link
                  to="/voice-of-vidyaloka"
                  className="text-secondary text-decoration-none"
                >
                  Voice of Vidyaloka
                </Link>
              </li> */}
              {/* <li className="mb-2">
                <i className="bi bi-chevron-right me-2"></i>
                <Link
                  to="/events"
                  className="text-secondary text-decoration-none"
                >
                  Events
                </Link>
              </li> */}
              <li className="mb-2">
                <i className="bi bi-chevron-right me-2"></i>
                <Link
                  to="/membership/register"
                  className="text-secondary text-decoration-none"
                >
                  Membership Registration
                </Link>
              </li>
              <li className="mb-2">
                <i className="bi bi-chevron-right me-2"></i>
                <Link
                  to="/membership/track-request"
                  className="text-secondary text-decoration-none"
                >
                  Track Membership Request
                </Link>
              </li>
              <li className="mb-2">
                <i className="bi bi-chevron-right me-2"></i>
                <Link
                  to="/contact"
                  className="text-secondary text-decoration-none"
                >
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact + Social Column */}
          <div className="col-12 col-sm-6 col-lg-4">
            <h5 className="mb-4 fw-bold">Contact Information</h5>

            <p className="mb-3 d-flex align-items-center">
              <div
                className="rounded-circle d-flex align-items-center justify-content-center me-3 bg-dark"
                style={{ width: "35px", height: "35px", flexShrink: 0 }}
              >
                <FontAwesomeIcon
                  icon={faLandmark}
                  className="text-white"
                  size="sm"
                />
              </div>
              <span className="text-secondary">
                Old Boys' Association <br /> Vidyaloka College, Galle
              </span>
            </p>

            <p className="mb-3 d-flex align-items-center">
              <div
                className="rounded-circle d-flex align-items-center justify-content-center me-3 bg-dark"
                style={{ width: "35px", height: "35px", flexShrink: 0 }}
              >
                <FontAwesomeIcon
                  icon={faPhone}
                  className="text-white"
                  size="sm"
                />
              </div>
              <span className="text-secondary">
                +94 72 224 1298 <br /> +94 91 224 1298
              </span>
            </p>

            <p className="mb-0 d-flex align-items-center">
              <div
                className="rounded-circle d-flex align-items-center justify-content-center me-3 bg-dark"
                style={{ width: "35px", height: "35px", flexShrink: 0 }}
              >
                <FontAwesomeIcon
                  icon={faEnvelope}
                  className="text-white"
                  size="sm"
                />
              </div>
              <span className="text-secondary">
                vidyalokaobagalle@gmail.com
              </span>
            </p>
            <div className="mt-3">
              <SocialMediaComponent showBox={false} />
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Copyright */}
      <div
        className="text-center text-white mt-4 py-3 bg-dark w-100"
        style={{ background: "#3C0008" }}
      >
        © {new Date().getFullYear()} Old Boys' Association of Vidyaloka College.
        All Rights Reserved.
      </div>

      {/* Scroll to Top Button */}
      {showScroll && (
        <button className="scroll-to-top-button bg-dark" onClick={scrollToTop}>
          <i className="bi bi-chevron-up"></i>
        </button>
      )}
    </footer>
  );
}
